import {VcrEntity} from '@app/models/vcr-entity/entity';
import {Group} from '@app/models/vcr-entity/group';

export class Lesson extends VcrEntity<any> {

  get id(): number {
    return this.data.id;
  }

  set id(id) {
    this.data.id = id;
  }

  get lessonNumber(): number {
    return this.data.lessonNumber;
  }

  set lessonNumber(lessonNumber: number) {
    this.data.lessonNumber = lessonNumber;
  }

  get group(): Group {
    return this.data.roomNum;
  }

  set group(group: Group) {
    this.data.group = group;
  }

  get title(): string {
    return this.data.title;
  }

  set title(title) {
    this.data.title = title;
  }
}
